import React, { FC } from 'react';
import ImageLink from 'components/commercetools-ui/atoms/ImageLink';
import { HeaderContentProps } from '../types/gmsb-header';

export interface Props {
  imageClassName?: string;
  ariaLabelLogo?: string;
  isDesktopSize: boolean;
  contentConfig: HeaderContentProps;
}

const HeaderLogo: FC<Props> = ({ isDesktopSize, contentConfig, imageClassName }) => {
  const {
    primaryLogoLight,
    primaryLogoLink,
    secondaryLogoLight,
    ariaLabelLogo,
    secondaryLogoLink,  
  } = contentConfig;

  const hasSecondary = !!(secondaryLogoLight?.src);

  const logoItems = [
    {
      media: primaryLogoLight,
      marginRight: isDesktopSize ? '8px' : '10px',
      logoLink: primaryLogoLink,
      ffidName: 'header-primary-logo'
    },
    {
      media:  secondaryLogoLight,
      marginRight: isDesktopSize ? '16px' : '0px',
      logoLink: secondaryLogoLink,
      ffidName: 'header-secondary-logo'
    },
  ];

  return (
    <div className="flex-0 relative flex flex-row items-center md:mt-0 w-210 h-30 lg:w-280 lg:h-40 ">
      {logoItems
        .filter((item) => item.media != null)
        .map((item) => {
          return (
            <ImageLink
              key={item.ffidName}
              media={item.media}
              link={item.logoLink}
              className={imageClassName}
              marginRight={item.marginRight}
              title={ariaLabelLogo}
              ffid={item.ffidName}
              hasSecondary={hasSecondary}
              imageClassNames={'object-scale-down'}
              cropType='scale'
              unoptimized={false}
            />
          );
        })}
    </div>
  );
};

export default HeaderLogo;
